import axios from 'axios';
import { get, post, put, remove } from './mainApi';

const resourceManagementBaseURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT + '/resources';

const resourceManagementSingleBaseURL =
  process.env.REACT_APP_WORKLOG_MANAGEMENT_ENDPOINT + '/resource';

export const getAllResourceManagements = async () => {
  var response = get(resourceManagementBaseURL);
  return response;
};

export const getSingleResourceManagements = async (id) => {
  var response = get(
    `${resourceManagementSingleBaseURL}/details?employeeId=${id}`
  );
  return response;
};

export const createResourceManagements = async (data) => {
  var response = post(`${resourceManagementSingleBaseURL}/create`, data);
  return response;
};

export const deAllocateResourceManagements = async (data) => {
  var response = put(`${resourceManagementSingleBaseURL}/deallocate`, data);
  return response;
};

export const updateResourceManagements = async (data) => {
  var response = put(`${resourceManagementSingleBaseURL}/update`, data);
  return response;
};

export const getQuickAccessTable = async (name: string) => {
  const response = post(`${resourceManagementSingleBaseURL}/quickresponse`, {
    projectName: name
  });
  return response;
};

export const searchResourceManagements = async (keyword: string) => {
  var response = post(`${resourceManagementSingleBaseURL}/search`, {
    nameInJira: keyword
  });
  return response;
};

export const filterResourceManagements = async (data: any) => {
  var response = post(`${resourceManagementSingleBaseURL}/filter`, data);
  return response;
};
